import { render } from "./LargeTitle.vue?vue&type=template&id=a57d4544"
import script from "./LargeTitle.vue?vue&type=script&lang=js"
export * from "./LargeTitle.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__